/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningAIcon20Solid = forwardRef('NatureFxLightningAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.42 2.133A1.375 1.375 0 0 1 6.773 1h5.21c.914 0 1.574.874 1.323 1.753L12.093 7h2.539c1.155 0 1.795 1.338 1.07 2.238l-7.495 9.305c-.686.85-2.056.236-1.876-.842l1.075-6.451H5.434A1.375 1.375 0 0 1 4.08 9.633l1.34-7.5Z" })));
});
